import React from 'react';
import { SvgIcon } from '@onsolve/onsolve-ui-components';

const Lookout = props => (
    <SvgIcon {...props}>
        <path
            d="M13.69 2.178c1.143-.403 2.197-.05 2.307.351l.003.013v8.942c-2.003.17-3.611 1.968-3.611 4.016 0 .17.01.336.031.5H9.54c.02-.164.032-.33.032-.5 0-2.16-1.776-4.016-3.935-4.016a3.91 3.91 0 00-3.909 3.912c0 .17-.02.44 0 .604H0c0-1.137.863-2.488 2.682-7.609C4.5 3.271 5.318 3.743 5.318 3.743c.344-1.717 1.473-1.972 2.629-1.565 1.156.407 1.023 2.165 1.023 2.19.55.254.95.706 1.201 1.358l.017.046h1.26l.017-.046c.252-.652.652-1.104 1.201-1.358l-.004-.09c-.009-.369.022-1.746 1.027-2.1zM10.5 10a1.5 1.5 0 00-.029 3h.029a1.5 1.5 0 00.029-3H10.5z"
            fill="#currentColor"
            fillRule="evenodd"
            stroke="none"
        />
    </SvgIcon>
);

export default Lookout;
